export default __webpack_public_path__ + "static/media/modal-close.ad8067ee.svg";